import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/lib/auth";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import Frameworks from "@/pages/Frameworks";
import FrameworkDetail from "@/pages/FrameworkDetail";
import Assessment from "@/pages/Assessment";
import Interview from "@/pages/Interview";
import Quizzes from "@/pages/Quizzes";
import QuizPlay from "@/pages/QuizPlay";
import Tutor from "@/pages/Tutor";
import Checklists from "@/pages/Checklists";
import Pricing from "@/pages/Pricing";
import AppShell from "@/components/AppShell";
import "@/App.css";

function Private({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-sm text-muted-foreground">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return <AppShell>{children}</AppShell>;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/app" element={<Private><Dashboard /></Private>} />
            <Route path="/app/frameworks" element={<Private><Frameworks /></Private>} />
            <Route path="/app/frameworks/:fid" element={<Private><FrameworkDetail /></Private>} />
            <Route path="/app/assessment" element={<Private><Assessment /></Private>} />
            <Route path="/app/interview" element={<Private><Interview /></Private>} />
            <Route path="/app/quizzes" element={<Private><Quizzes /></Private>} />
            <Route path="/app/quizzes/:qid" element={<Private><QuizPlay /></Private>} />
            <Route path="/app/tutor" element={<Private><Tutor /></Private>} />
            <Route path="/app/checklists" element={<Private><Checklists /></Private>} />
            <Route path="/app/pricing" element={<Private><Pricing /></Private>} />
          </Routes>
        </BrowserRouter>
        <Toaster position="bottom-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
